export default "/images/no-data.png?46b16fbf84ca5b1924f50b095ee3b113";